var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9469 0.0797844C13.8114 0.0140666 13.66 -0.0118612 13.5103 0.00501233C13.3606 0.0218859 13.2188 0.0808675 13.1013 0.17511L5.31813 6.40053H1.60037C1.1762 6.40142 0.769656 6.57032 0.46972 6.87025C0.169784 7.17019 0.000888943 7.57673 0 8.00091V14.4013C0.000593958 14.8254 0.16943 15.232 0.469462 15.5319C0.769494 15.8317 1.17621 16.0002 1.60037 16.0005H5.31813L13.0991 22.2271C13.242 22.3394 13.4185 22.4006 13.6004 22.4009C13.8123 22.4003 14.0153 22.3159 14.1651 22.166C14.315 22.0162 14.3994 21.8132 14.4 21.6013V0.800905C14.3998 0.650285 14.3572 0.502758 14.2771 0.375222C14.197 0.247687 14.0825 0.145299 13.9469 0.0797844Z",
    fill: "#E5E7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerOff);
export default __webpack_public_path__ + "static/media/speaker-off.0dbb68978e8556cce2395585eaf84010.svg";
export { ForwardRef as ReactComponent };